import { environment, Role } from '@perval/shared';
import { MenuItem } from './main-menu';

export const ACCOUNT_MENU: MenuItem[] = [
  {
    label: 'Mon profil',
    route: `/profil`,
    requiredRoles: [Role.AUTHENTICATED],
    v2: true,
  },
  {
    label: 'Gestion des droits d’accès',
    route: `${environment.host}/habilitation`,
    requiredRoles: [
      Role.ADMIN,
      Role.NOTARY,
      Role.COLLABORATOR,
      Role.COLLABORATOR_LIMITED,
    ],
  },
  {
    label: 'Historique des services',
    route: `/historique-des-services`,
    requiredRoles: [Role.SERVICES_HISTORY_LIST],
    v2: true,
  },
  {
    label: 'Alimentation des bases immobilières',
    route: `${environment.host}/alimentation-base/alimentation-contrats`,
    requiredRoles: [
      Role.ADMIN,
      Role.NOTARY,
      Role.COLLABORATOR,
      Role.COLLABORATOR_LIMITED,
    ],
  },
  {
    label: 'Commande de crédits',
    route: `/commande-de-credits`,
    requiredRoles: [
      Role.ADMIN,
      Role.NOTARY,
      Role.COLLABORATOR,
      Role.COLLABORATOR_LIMITED,
    ],
    v2: true,
  },
  {
    label: 'Historique des consommations',
    route: `${environment.host}/historique/consommations`,
    requiredRoles: [Role.AUTHENTICATED],
  },
];
